<template>
  <p class="margin-0">
    <a
      :href="userSdnAgree ? scholarPath : 'javascript:void(0)'"
      :target="userSdnAgree ? '_blank' : ''"
      class="promo-message-link"
      data-open-modal
      @click="onClickHandler"
    >
      {{ linkTitle }}
    </a>
  </p>
  <div
    class="cart-indicator"
    v-if="showCardIndicator"
  >
    {{ discountNumber }}
  </div>
  <div class="hidden">
    <intake-form-overlay
      v-if="showOverlay"
      :imageUrl="imageUrl"
      :scholarPath="scholarPath"
      :profileCompleted="profileCompleted"
      :userInfoMilitaryAffiliation="userInfoMilitaryAffiliation"
      :userInfoMilitaryAffiliationDetails="userInfoMilitaryAffiliationDetails"
    />
  </div>
</template>

<script>
  import IntakeFormOverlay from './intake_form_overlay'
  import $ from 'jquery'
  import { mapGetters } from 'vuex';

  export default {
    props: {
      imageUrl: {
        type: String
      },
      scholarPath: {
        type: String
      },
      isBannerLink: {
        type: Boolean
      },
      profileCompleted: {
        type: Boolean
      },
      userInfoMilitaryAffiliation: {
        type: String
      },
      userInfoMilitaryAffiliationDetails: {
        type: String
      }
    },

    components: {
      IntakeFormOverlay
    },

    computed: {
      ...mapGetters(['userSdnAgree', 'discountNumber']),

      showOverlay() {
        return !this.userSdnAgree && $(".intake-form-overlay").length == 0
      },
      linkTitle() {
        return this.isBannerLink? 'Browse Scholarships & Discounts' : 'Scholarships & Discounts'
      },
      showCardIndicator() {
        return !this.isBannerLink && this.discountNumber > 0
      }
    },
    methods: {
      onClickHandler() {
        $('.intake-form-overlay').foundation('open');

        this.onCloseModal()
      },
      onCloseModal() {
        const modal = $('#intakeFormOverlay')

        const closeModal = '[data-close], .cancel-button'
        let closeTrigger = null
        let countClosed = 0

        $(document).on('click', closeModal, (e) => { // if some link is clicked to close the popup
          const $closeLink = $(e.target)
          closeTrigger = true
          SOPHIA.clickModalCloseForGA($closeLink, modal)
        });

        $(document).on('closed.zf.reveal', modal, (e) => {
          if (countClosed == 0) { // prevent repeated messages
            setTimeout(() => {
              countClosed += 1
              if (!closeTrigger) { // if the modal was closed not via link click
                const $modal = $(e.target)
                SOPHIA.clickModalCloseForGA(false, $modal) // send GA only for the current closed modal
              } else { // set closeTrigger to null for other modals
                closeTrigger = null
              }
            }, 500)
          }
        })
      }
    },
    mounted() {
      $(document).foundation()
      SOPHIA.clickLinkForGA($('body'));

      $("a[data-open]").off('click.openzf').on('click.openzf', function(e) {
        $(document).on('open.zf.reveal', '[data-reveal]', () => {
          SOPHIA.formGA($('#intake-form'), 'form_view')

          snowplow('trackStructEvent', {
            category: 'sdn_first_intake_form',
            action: 'impression'
          })
        })
      })
    }
  }
</script>

